import { useEffect } from 'react';
import { useCompany } from '../../hooks/useCompany';
import { useAllowedFeatures } from '../../hooks/useFeaturePersonalization';
import { LicenseProvider } from '../../hooks/useLicense';
import { useShowLicenseSelfServeRenewalResultModal } from '../../hooks/useShowLicenseSelfServeRenewalResultModal';
import { useFetchLicenseListQuery } from '../../services/license.api';
import { SCOPE_TYPE } from '../../services/utils';
import LicenseFilters from './filters/LicenseFilters.component';
import LicensesGrid from './LicensesGrid.component';
import LicensesWrapper from './LicensesWrapper.component';
import NoLicense from './NoLicense.component';
import SelfServiceRenewablesSummary from './SelfServeRenewablesSummary.component';
import SupportLicensesHeader from './SupportLicensesHeader.component';

const SupportLicenses = () => {
  const { userScope } = useCompany();
  const { allowSelfServeRenewals, isCompanyLoading } = useAllowedFeatures();
  const { licensesTotalCount, isLoading } = useFetchLicenseListQuery(
    // In case userScope is undefined in order to avoid the error sending the restricted scope "COMPANY"
    { scope: userScope || SCOPE_TYPE.COMPANY },
    {
      selectFromResult: (endPoint) => ({
        isLoading: (endPoint.isLoading || endPoint.isFetching) && !endPoint?.data,
        licensesTotalCount: endPoint.data?.totalCount || 0,
      }),
    },
  );
  const { showRenewalResultModal, displayRenewalResult } =
    useShowLicenseSelfServeRenewalResultModal();

  useEffect(() => {
    if (showRenewalResultModal) {
      displayRenewalResult();
    }
  }, [showRenewalResultModal, displayRenewalResult]);

  return !licensesTotalCount ? (
    <LicensesWrapper headerChildren={<SupportLicensesHeader />}>
      <NoLicense isLoading={isLoading} />
    </LicensesWrapper>
  ) : (
    <LicenseProvider>
      {!isCompanyLoading && allowSelfServeRenewals && <SelfServiceRenewablesSummary />}
      <LicensesWrapper headerChildren={<SupportLicensesHeader />}>
        <LicenseFilters />
        <LicensesGrid />
      </LicensesWrapper>
    </LicenseProvider>
  );
};

export default SupportLicenses;
